import React, { useState } from 'react';
import { Alert, Box, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material';
import { EntityEditDialog } from '@lp/lp-ui';
import useCache from '../../app/useCache';
import { CachedEntity } from '../../app/cacheSlice';
import RoleSelector from '../common/RoleSelector';

interface BulkAssignRolesDialogProps {
    open: boolean;
    onClose: () => void;
    onSave: (roleIds: number[], enable: boolean) => void;
}

const BulkAssignRolesDialog: React.FC<BulkAssignRolesDialogProps> = ({ open, onClose, onSave }) => {
    const roles = useCache(CachedEntity.Role);
    const [selectedIds, setSelectedIds] = useState<number[]>([]);
    const [action, setAction] = useState<string>('');

    const hasSelection = selectedIds.length > 0;

    const handleClose = () => {
        setSelectedIds([]);
        setAction('');
        onClose();
    };

    const handleSave = () => {
        onSave(selectedIds, action === 'enable');
        setSelectedIds([]);
        setAction('');
    };

    return (
        <EntityEditDialog
            open={open}
            maxWidth="md"
            fullWidth
            title="Roles"
            handleClose={handleClose}
            handleSave={handleSave}
            editing={true}
            disableSave={!hasSelection || !action}
        >
            <Alert severity="info" sx={{ mb: 2 }}>
                This action will be executed in the background and it may take some time for all changes to take effect.
            </Alert>
            <RoleSelector
                roles={roles}
                selectedIds={selectedIds}
                onChange={setSelectedIds}
                namePrefix="bulk-role"
                height={380}
            />
            <Box sx={{ mt: 2 }}>
                <FormControl>
                    <FormLabel>Action</FormLabel>
                    <RadioGroup row value={action} onChange={(e) => setAction(e.target.value)}>
                        <FormControlLabel value="enable" control={<Radio />} label="Enable" />
                        <FormControlLabel value="disable" control={<Radio />} label="Disable" />
                    </RadioGroup>
                </FormControl>
            </Box>
        </EntityEditDialog>
    );
};

export default BulkAssignRolesDialog;
